import React, { Component } from "react";
import { Link, useParams } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { login, googleSignIn, verifyOTP } from "../../actions/auth";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import googleImage from "../../assets/images/google.png";
import microsoftImage from "../../assets/images/microsoft.png";
import { color, maxWidth } from "@material-ui/system";
// import brandsek from "../../assets/images/brandsek-logo.png"
import { GOOGLE_LOGIN_URL, MICROSOFT_LOGIN_URL } from "../../utils/constant";
import logo from "../../assets/images/salek-logo.webp";
import brandsekLoginBanner from "../../assets/images/login.png";

var Model = require("./model");

class Login extends Component {
  state = {
    user: null,
    visiblePassword: false,
    authMethod: null,
    loading: false,
    showPassword: false,
    setOtp: '',
    errorMessage: null
  };

  componentDidMount() {
    // Extract error parameter from URL
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    if (error) {
      this.setState({ errorMessage: this.getErrorMessage(error) });
    }
  }

  getErrorMessage = (errorType) => {
    const errorMessages = {
      'user-not-found': {
        icon: '🔴',
        message: "We couldn't find an account with that information. Please check your email or username and try again."
      },
      'subscription-expired': {
        icon: '⚠️',
        message: "Your subscription has expired. Please renew to continue using your account."
      },
      'revoked': {
        icon: '⛔',
        message: "Your access has been revoked. Contact support if you believe this is a mistake."
      },
      'not-active': {
        icon: '⏸️',
        message: "Your account is currently inactive. Please activate your account or contact support for assistance."
      }
    };

    return errorMessages[errorType] || null;
  };

  clearErrorMessage = () => {
    this.setState({ errorMessage: null });
    // Clear URL parameter
    const url = new URL(window.location);
    url.searchParams.delete('error');
    window.history.replaceState({}, document.title, url.pathname);
  };

  componentDidUpdate() {
    const redirectPath = localStorage.getItem('redirectPath');
    if (this.props.auth.user && this.state.loading) {
      this.setState({
        user: this.props.auth.user,
        loading: false,
      });
      
      if (this.props.auth.user.passwordReset) {
        // If there's a stored redirect path, use it regardless of user role
        if (redirectPath) {
          this.props.history.replace(redirectPath);
          localStorage.removeItem('redirectPath'); // Clear stored path
          return;
        }
        
        // If no redirect path, use role-based redirects
        if (this.props.auth.user.accessLevel === "Client") {
          this.props.history.replace("/");
        } else if (
          this.props.auth.user.accessLevel === "MSSP" ||
          this.props.auth.user.accessLevel === "Threat Analyst"
        ) {
          this.props.history.replace("/clients");
        } else if (this.props.auth.user.accessLevel === "tprm-question-responder") {
          this.props.history.replace("/risk-management-dashboard-vendor");
        } else {
          this.props.history.replace("/");
        }
      } else {
        this.props.history.replace("/reset-password");
      }
    }
  }

  handleLogin = (event) => {
    event.preventDefault();
    let email = $("#email").val();
    let password = $("#password").val();
    let otp;
    if (email == "") {
      toastr.error("Error", "Please enter email id");
      return false;
    }
    if (password == "") {
      toastr.error("Error", "Please enter password");
      return false;
    }
    if (this.state.authMethod == "TwoFactor") {
      otp = $("#twoFactor").val();
      if (otp == "") {
        toastr.error("Error", "Please enter otp");
        return false;
      }
    }
    this.setState({ loading: true });
    if (this.state.authMethod == "TwoFactor") {
      this.props.login({
        email,
        password,
        otp
      });
    } else {
      this.props.login({
        email,
        password,
      });
    }
  };

  verifyOTP = () => {
    let otp = $("#otp").val();
    this.props.verifyOTP({
      token: this.props.auth.twoFactor.authToken,
      otp: otp,
    });
  };

  onNext = (e) => {
    e.preventDefault();
    let email = $("#email").val();
    // this.setState({ loading: true }, function () {
    Model.default.getAuthMethod(email).then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        this.setState({
          loading: false,
          authMethod: response.data.data,
        });
      }
    });
    // });
  };

  loginByGoogle = (event) => {
    event.preventDefault();
    window.open(GOOGLE_LOGIN_URL);
    // let email = $("#email").val();
    // this.props.googleSignIn(email);
  };

  loginByMicrosoft = (event) => {
    event.preventDefault();
    window.open(MICROSOFT_LOGIN_URL);
    // let email = $("#email").val();
    // this.props.googleSignIn(email);
  };

  handleNumChange = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  };

  render() {
    let brandsek = "../../assets/images/image-gallery/brandsek-logo.svg";
    let browser = window.location.href.split("/")
    if (browser[2].split(".")[0] && browser[2].split(".")[0] == "brandshield") {
      brandsek = '../../assets/images/image-gallery/Final_Logo.png'
    } else if (browser[2].split(".")[0] && browser[2].split(".")[0] == "invinsense") {
      brandsek = '../../assets/images/image-gallery/Invinsense_logo_white.png?v=1'
    }
    return (
      <>
        <div className="page-wrapper page-wrapper_login">
          <div className="section bg-default wf-section">
            <div className="container-fluid p-0">
              <div className="row m-0" style={{ display: "flex", flexWrap: "wrap", marginRight: "-15px", marginLeft: "-15px", alignItems: "center", height: "100vh" }}>
                <div className="col-md-7 p-0">
                  <div className="login-image">
                    <img src={brandsekLoginBanner} alt="brandsek" />
                    <h2 className="login-image-heading">Secure your digital world—because every click matters</h2>
                  </div>
                </div>
                <div className="col-md-5 p-0">
                  <div className="sign-form w-form">
                    <form
                      className="form-auth-small m-t-20"
                    >
                      <div className="sign-card-content">
                        <div className="loginContentBox">
                          <img src={logo} className="img-fluid" alt="brandsek" />
                          <h2 className="display-2 text-center mg-bottom-24px keep"
                          >Log In to your account.</h2>
                          <p className="text-center mg-bottom-24px keep"
                          >Enter your details below to sign in</p>
                          
                          {this.state.errorMessage && (
                            <div className="alert alert-danger text-center mg-bottom-24px" style={{
                              backgroundColor: '#f8d7da',
                              borderColor: '#f5c6cb',
                              color: '#721c24',
                              padding: '12px 20px',
                              borderRadius: '8px',
                              border: '1px solid',
                              fontSize: '14px',
                              lineHeight: '1.4',
                              position: 'relative'
                            }}>
                              <button 
                                onClick={this.clearErrorMessage}
                                style={{
                                  position: 'absolute',
                                  top: '8px',
                                  right: '12px',
                                  background: 'none',
                                  border: 'none',
                                  fontSize: '18px',
                                  cursor: 'pointer',
                                  color: '#721c24',
                                  padding: '0',
                                  lineHeight: '1'
                                }}
                                title="Dismiss"
                              >
                                ×
                              </button>
                              <span style={{ marginRight: '8px', fontSize: '16px' }}>
                                {this.state.errorMessage.icon}
                              </span>
                              {this.state.errorMessage.message}
                            </div>
                          )}
                        </div>
                        <div className="mg-bottom-24px keep">
                          <div>
                            <div>
                              <label htmlFor="email" className="form-label">Email Address</label>
                              <input type="email" className="input input-form top w-input"
                                name="Email" data-name="Email" placeholder="Email address" id="email"
                                onChange={() => this.state.errorMessage && this.clearErrorMessage()}></input>
                            </div>
                            {this.state.authMethod && this.state.authMethod == "default" && (
                              <div className="has-feedback position-relative mb-3">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input className="input input-form bottom w-input"

                                  type={this.state.showPassword ? "text" : "password"}
                                  name="Password" data-name="Password" placeholder="Password" id="password"
                                  onChange={() => this.state.errorMessage && this.clearErrorMessage()}></input>
                                <i
                                  style={{
                                    position: "absolute",
                                    top: "55px",
                                    right: "15px",
                                    width: "34px",
                                    textAlign: "center",
                                    height: "34px",
                                    zIndex: "2",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    color: "#453AD1"
                                  }}
                                  className={
                                    this.state.showPassword
                                      ? "form-control-feedback fa fa-eye-slash"
                                      : "form-control-feedback fa fa-eye"
                                  }
                                  onClick={() =>
                                    this.setState({ showPassword: !this.state.showPassword })
                                  }
                                ></i>
                              </div>
                            )}

                            {this.state.authMethod && this.state.authMethod == "TwoFactor" && (
                              <>
                                <div className="has-feedback position-relative mb-3">
                                  <label htmlFor="password" className="form-label">Password</label>
                                  <input className="input input-form w-input"

                                    type={this.state.showPassword ? "text" : "password"}
                                    name="Password" data-name="Password" placeholder="Password" id="password"
                                    onChange={() => this.state.errorMessage && this.clearErrorMessage()}></input>
                                  <i
                                    style={{
                                      position: "absolute",
                                      top: "55px",
                                      right: "15px",
                                      width: "34px",
                                      textAlign: "center",
                                      height: "34px",
                                      zIndex: "2",
                                      cursor: "pointer",
                                      fontSize: "16px",
                                      color: "#453AD1"
                                    }}
                                    className={
                                      this.state.showPassword
                                        ? "form-control-feedback fa fa-eye-slash"
                                        : "form-control-feedback fa fa-eye"
                                    }
                                    onClick={() =>
                                      this.setState({ showPassword: !this.state.showPassword })
                                    }
                                  ></i>
                                </div>
                                <div className="has-feedback position-relative mb-3">
                                  <label htmlFor="twoFactor" className="form-label">OTP</label>
                                  <input className="input input-form bottom w-input"

                                    type="text"
                                    name="twoFactor" data-name="twoFactor" placeholder="OTP" id="twoFactor"></input>

                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="mg-bottom-24px keep">
                          <div className="text-200 medium color-neutral-100 linkButton">
                            <Link to="/forgotpassword">Forgot password?</Link>
                          </div>
                        </div>
                        {this.props.auth.twoFactor && (
                          <div className="form-group has-feedback">
                            <label htmlFor="password" className="control-label sr-only">
                              Otp
                            </label>
                            <input
                              style={{ paddingRight: "30px" }}
                              type="number"
                              className="form-control-new round"
                              id="otp"
                              // value={this.state.setOtp}
                              maxLength={6}
                              onChange={this.handleNumChange}
                              placeholder="One Time Password"
                            />
                            {/* <i className={this.state.showPassword ? "form-control-feedback fa fa-eye-slash" : "form-control-feedback fa fa-eye"} onClick={() => this.setState({showPassword : !this.state.showPassword})}></i> */}
                          </div>
                        )}
                        {this.state.authMethod && (
                          <button type="submit" value="Sign in"
                            style={{ color: "black !important" }}
                            className="loginButton btn-primary width-100 w-button loginsignbutton"
                            onClick={this.handleLogin}
                            onMouseDown={(e) => e.target.style.color = 'black'}>Sign in</button>
                        )}
                        {!this.state.authMethod && (
                          <button type="submit" value="Next"
                            style={{ color: "black !important" }}
                            className="loginButton btn-primary width-100 w-button loginsignbutton"
                            onClick={this.onNext}
                            onMouseDown={(e) => e.target.style.color = 'black'}>Next</button>
                        )}
                      </div>
                      <div className="divider_Login">
                        OR
                      </div>
                      <div className="sign-card-content">

                        {
                          browser[2].split(".")[0] != "brandshield" && (
                            <button onClick={this.loginByGoogle}
                              className="loginGoogle btn-secondary sign-in-button mg-bottom-16px keep w-button w-100">
                              <img src={googleImage} alt="Google Icon" className="button-icon-left img-fluid mr-2" />
                              Sign in with google</button>
                          )}

{
                          browser[2].split(".")[0] != "brandshield" && (
                            <button onClick={this.loginByMicrosoft}
                              className="loginGoogle btn-secondary sign-in-button mg-bottom-16px keep w-button w-100">
                              <img src={microsoftImage} alt="Google Icon" className="w-5 h-5 mr-2 inline-block" />
                              Sign in with Microsoft </button>
                          )}
                      </div>
                    </form>
                    <div style={{ textAlign: 'center', padding: '10px', fontSize: '14px', color: '#666', marginTop:'20px' }}>
                      Powered by brandsek
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    auth,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
      googleSignIn,
      verifyOTP,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
